import get from 'lodash.get';
import uniq from 'lodash.uniq';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectFormattedVarieties } from 'services/varieties/selectors';
import { selectSprayEventsForSubmissionVarietyIdsArray } from 'services/sprayEventsForSubmission/selectors';

const selectVariety = createDeepEqualSelector(
    selectSprayEventsForSubmissionVarietyIdsArray,
    selectFormattedVarieties,
    (sprayEventVarietyIds, varieties) => {
        if (sprayEventVarietyIds.length) {
            const varietiesArray = sprayEventVarietyIds.map((varietyId) => {
                return varietyId ? get(varieties, [varietyId, 'name']) : null;
            });

            return uniq(varietiesArray).join(', ');
        }

        return null;
    }
);

const makeSelectVariety = (): typeof selectVariety => selectVariety;

export { makeSelectVariety };
